import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out
  useEffect(() => {
    const token = localStorage.getItem("bides_token");
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => { localStorage.setItem("bides_user", JSON.stringify(r.data)); setUser(r.data); })
      .catch((e) => {
        const cached = localStorage.getItem("bides_user");
        if (!e.response && cached) { setUser(JSON.parse(cached)); return; }
        localStorage.removeItem("bides_token");
        localStorage.removeItem("bides_user");
        setUser(false);
      });
  }, []);

  const login = (token, u) => {
    localStorage.setItem("bides_token", token);
    localStorage.setItem("bides_user", JSON.stringify(u));
    setUser(u);
  };
  const logout = () => {
    localStorage.removeItem("bides_token");
    localStorage.removeItem("bides_user");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
